import React from 'react'
import { useMutation } from 'react-query'
import { Delete } from 'src/apis/api'
import Loading from 'src/components/Loading'
import { DeleteIcon } from 'src/icons/icons'
import { useJobLevels } from '../../hooks'
import { useTranslation } from 'react-i18next'
import { ResponseType } from 'src/types'
import { toast } from 'react-toastify'

export const DeleteJobLevel = ({ id }: { id: string }) => {

    const { refetch } = useJobLevels()

    const { t } = useTranslation();


    const { isLoading, data, mutate } = useMutation<ResponseType<any>, {}, {}, {}>({
        mutationFn: (data) => Delete(`/basic-information/job-levels/destroy/${id}`) as any,
        mutationKey: ['DeleteJobLevel', id],
        onSuccess: (d) => {
            toast.success(d.msg)
            refetch()
        },
        onError: (e) => {
        }
    })

    const handleDelete = () => {
        if(prompt(t('AreYouSureToDeleteJobLevel'),t('Yes')))
        {
            mutate({})
        }
    }


    return (
        <div className='flex ' onClick={handleDelete}>
            {isLoading ? <Loading /> : <DeleteIcon />}
        </div>
    )
}
